var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"my-nav fixed-top",attrs:{"fluid":""}},[_c('b-container',{staticClass:"smfluid"},[_c('img',{staticClass:"tg-logo",attrs:{"src":"/../fdtiger-offical-site-img/navbar_footer/text_logo.png","alt":"tg-logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }